import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';

@Injectable({ providedIn: 'root' })
export class ToastService {
  private readonly message = inject(MessageService);

  warn(summary: string, detail: string, life = 4000): void {
    this.message.add({ severity: 'warn', summary, detail, life });
  }

  error(summary: string, detail: string, life = 5000): void {
    this.message.add({ severity: 'error', summary, detail, life });
  }

  success(summary: string, detail: string, life = 4000): void {
    this.message.add({ severity: 'success', summary, detail, life });
  }

  info(summary: string, detail: string, life = 4000): void {
    this.message.add({ severity: 'info', summary, detail, life });
  }
}
